import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GrLabel } from ".";
import { GrStack } from "../layout";
import { palette } from "../../theme/palette";
import styled from "@emotion/styled";
import { Radio } from "@mui/material";
import classNames from "classnames";
const radioColor = (color) => {
    const colors = {
        primary: palette["maven-blue-dark"],
        gray: palette.grey080,
        orange: palette.orange050,
        red: palette.red060,
        green: palette.green060,
        purple: palette.purple060,
        navy: palette.darkNavy050,
    };
    return colors[color !== null && color !== void 0 ? color : "primary"];
};
const StyledRadio = styled(Radio)(props => ({
    ".MuiSvgIcon-root": {
        width: (props.size === "large" && "20px") || "16px",
        height: (props.size === "large" && "20px") || "16px",
        path: {
            fill: ((props.disabled || props.readonly) && palette.grey030) || (props.checked && radioColor(props.radioColor)) || palette.grey040,
        },
    },
    padding: "0",
    margin: "0",
    ...props.style,
}));
export function GrRadio({ size, readonly, disabled, label, className, color, ...props }) {
    var _a, _b, _c, _d;
    return (_jsxs(GrStack, { className: "GrRadio-wrapper", display: "inline-flex", flexDirection: (_a = label === null || label === void 0 ? void 0 : label.flexDirection) !== null && _a !== void 0 ? _a : "row", gap: (_b = label === null || label === void 0 ? void 0 : label.gap) !== null && _b !== void 0 ? _b : "6px", alignItems: ((_c = label === null || label === void 0 ? void 0 : label.flexDirection) === null || _c === void 0 ? void 0 : _c.includes("column")) ? "flex-start" : "center", children: [_jsx(StyledRadio, { className: classNames("GrRadio", className), size: size, readonly: readonly, disabled: disabled, value: props.value, radioColor: color, ...props }), (label === null || label === void 0 ? void 0 : label.text) && (_jsx(GrLabel, { ...label, htmlFor: props.id, style: {
                    marginTop: ((_d = label.flexDirection) === null || _d === void 0 ? void 0 : _d.includes("column")) ? (size === "large" ? "17px" : "13px") : 0,
                    fontSize: size === "large" ? "16px" : "14px",
                    fontWeight: 400,
                    padding: "0 2px",
                    color: (disabled && palette.grey030) || (readonly && palette.grey060) || palette.grey090,
                    ...label.style,
                } }))] }));
}
//# sourceMappingURL=GrRadio.js.map